import React, { useState, useCallback, forwardRef, useImperativeHandle } from 'react'
import { useDispatch } from 'react-redux'
import { setShowPopupMarkerId } from '@/store/slice/marker'
import GoogleMapReact from 'google-map-react'
import Marker from '@components/Marker'
import * as Geohash from '@/modules/geohash'
import * as Gmap from '@/modules/googlemap'
import * as mapConfig from '@data/map'
import * as order from '@data/order'

const GoogleMap = (props, ref) => {
  const { stores } = props
  const dispatch = useDispatch()
  const [isGmapInit, setGmapInit] = useState(false)
  const [geohashs, setGeohashs] = useState([])

  // ['a' ,'abc'] => "^a.*|^abc.*""
  const pattern = geohashs.map((v) => `^${v}.*`).join('|')
  const regex = new RegExp(pattern, 'i')

  const onMapStores = stores.reduce((storeList, store) => {
    if (regex.test(store.geohash)) {
      storeList.push(store)
    }
    return storeList
  }, [])

  onMapStores.sort((storeA, storeB) => {
    // CHACHA門市>屈臣氏>康是美>寶雅>年青人>眼鏡行>家樂福
    return order.channel[storeA.channel] - order.channel[storeB.channel]
  })

  const onBoundsChange = useCallback(({ center, bounds }) => {
    const geohashesInRadius = Geohash.getAllGeohashsInBounds(center, bounds)
    setGeohashs(geohashesInRadius)
  }, [])

  const onGoogleMapLoaded = useCallback(({ map, maps }) => {
    Gmap.initial(map, maps)
    setGmapInit(true)
  }, [])

  // TODO: be react hook
  const onMarkerClick = useCallback((store) => {
    const { lat, lng } = store.latlng
    Gmap.panTo(lat, lng)
    dispatch(setShowPopupMarkerId(store.storeid))
  }, [dispatch])

  useImperativeHandle(ref, () => ({
    focus(store) {
      onMarkerClick(store)
    }
  }))

  const markers = !isGmapInit ? null : onMapStores.map((store) => {
    const { lng, lat } = store.latlng
    return (
      <Marker lat={lat} lng={lng} key={store.storeid} store={store} onClick={onMarkerClick} />
    )
  })

  return (
    <GoogleMapReact
      bootstrapURLKeys={mapConfig.urlParams}
      defaultCenter={mapConfig.center}
      defaultZoom={mapConfig.zoom}
      options={mapConfig.options}
      onChange={onBoundsChange}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={onGoogleMapLoaded}
    >
      {markers}
    </GoogleMapReact>
  )
}

export default forwardRef(GoogleMap)